<div class="page-wrapper">
  <!-- 🔎 Filtro admin -->
  <app-filter [tOp]="'admin'" [adminMode]="true" (search)="getPropiedades($event)"></app-filter>

  <!-- ➕ Botón agregar -->
  <div class="text-end mb-3 mt-3">
    <a [routerLink]="['/admin/nuevo']" class="btn btn-primary">
      <i class="fas fa-plus"></i> Nueva Propiedad
    </a>
  </div>

  <!-- 🏠 Lista -->
   <div class="prop-list-scroll">
  <div *ngFor="let propiedad of propiedades" class="prop-card">
    <div class="row g-3 align-items-center">
      <!-- Imagen -->
      <div class="col-12 col-md-2">
          <div class="prop-img-wrapper">
        <img [src]="propiedad.imagenes?.length > 0 ? (propiedad.imagenes[0].thumbnail | noimage) : ('' | noimage)"
             alt="Foto propiedad"
             class="prop-img noimage shadow-sm">
      </div>
    </div>

      <!-- Dirección y ubicación -->
      <div class="col-12 col-md-4 prop-info">
        <h5 class="prop-title">{{propiedad.tipoPropiedad.descripcion}}</h5>
        <div><i class="fas fa-map-marker-alt text-muted"></i> {{propiedad.domicilio.calle}} {{propiedad.domicilio.numero}}</div>
        <div><small>{{propiedad.domicilio.barrio.localidad.descripcion}} - {{propiedad.domicilio.barrio.descripcion}}</small></div>

        <!-- Características completas -->
        <div class="prop-caract mt-2">
          <span *ngFor="let item of propiedad.caracteristicasPropiedad"
                class="badge bg-light text-dark"
                [innerHtml]='item | iconspipe'>
          </span>
        </div>
      </div>

      <!-- Operación y precio -->
      <div class="col-12 col-md-3 text-md-center">
        <div class="badge bg-light text-dark mb-2">{{propiedad.tipoOperacion.descripcion}}</div>
        <div class="prop-precio">
          {{ propiedad.tipoMoneda.code === 'ARS' ? '$' : 'U$S'}} {{propiedad.precio | number}}
        </div>
      </div>

      <!-- Acciones -->
      <div class="col-12 col-md-3 text-end">
  <div class="d-flex flex-wrap justify-content-end gap-2 prop-actions">
    <a class="btn btn-outline-secondary btn-sm" 
       [routerLink]="['/admin/upload/',propiedad.id]" 
       tooltip="Cargar fotos">
      <i class="fas fa-camera"></i>
    </a>

    <a class="btn btn-outline-primary btn-sm" 
       [routerLink]="['/admin/editar/',propiedad.id]" 
       tooltip="Editar">
      <i class="fas fa-edit"></i>
    </a>

    <button class="btn btn-outline-warning btn-sm"
            (click)="CambiarEstado(propiedad.id, propiedad.habilitado)"
            [attr.aria-label]="propiedad.habilitado ? 'Deshabilitar' : 'Habilitar'">
      <i class="fas" [ngClass]="propiedad.habilitado ? 'fa-eye-slash' : 'fa-eye'"></i>
    </button>

    <button class="btn btn-outline-danger btn-sm" 
            (click)="Delete(propiedad.id)" 
            tooltip="Eliminar">
      <i class="fas fa-trash"></i>
    </button>
  </div>
</div>

    </div>
  </div>
  </div>
</div>
